import { render, staticRenderFns } from "./AdminSlugs.vue?vue&type=template&id=57b4bd80&scoped=true&"
import script from "./AdminSlugs.vue?vue&type=script&lang=js&"
export * from "./AdminSlugs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b4bd80",
  null
  
)

export default component.exports